const COVID19_CANCELLATION_WORKFLOW = [
  {
    type: 'confirm',
    question:
      'We are sorry to hear that your business is struggling due to the current circumstances surrounding COVID-19.\n We are currently offering support through reduced rate packages for applicable businesses. Please contact support@groovehq.com prior to cancelling to see if we can assist.',
    triggerCancelAccount: true,
  },
]
const STANDARD_CANCELLATION_WORKFLOW = [
  {
    type: 'text',
    question: 'Please share more details so we can improve',
  },
  {
    type: 'radio',
    question: 'Are you switching to an alternative tool? If so, which one?',
    answers: [
      {
        text: 'Yes',
        workflow: [
          {
            type: 'radio',
            question: 'Which one?',
            answers: [
              'Desk.com (a salesforce company)',
              'Freshdesk',
              'Hubspot',
              'Zendesk',
              'Frontapp',
              'Helpscout',
              'Other',
            ],
          },
        ],
      },
      'No',
      'Don’t know',
    ],
  },
  {
    type: 'confirm',
    question:
      'Thank you for providing us with the information.\nAre you sure you would still like to cancel?',
    triggerCancelAccount: true,
  },
]

export const CANCELLATION_WORKFLOW = [
  {
    type: 'radio',
    question: 'Please give us feedback before you cancel so we can improve.',
    answers: [
      {
        text: 'We liked Groove - we are cancelling for other reasons',
        workflow: [
          {
            type: 'radio',
            question:
              'Which of the following best describes your reason for cancelling?',
            answers: [
              {
                text: 'Due to circumstances resulting from COVID-19',
                workflow: COVID19_CANCELLATION_WORKFLOW,
              },
              {
                text: 'My organization is cutting costs',
                workflow: STANDARD_CANCELLATION_WORKFLOW,
              },
              {
                text:
                  'Setting up Groove or using Groove now doesn’t match up with my company’s timeline',
                workflow: STANDARD_CANCELLATION_WORKFLOW,
              },
              {
                text:
                  'Our business needs changed (e.g. project discontinued, funding issues, business failed etc.)',
                workflow: STANDARD_CANCELLATION_WORKFLOW,
              },
              {
                text: 'Only wanted to see what Groove does',
                workflow: STANDARD_CANCELLATION_WORKFLOW,
              },
              {
                text: 'Never got around to using it',
                workflow: STANDARD_CANCELLATION_WORKFLOW,
              },
              {
                text: 'Other',
                workflow: STANDARD_CANCELLATION_WORKFLOW,
              },
            ],
          },
        ],
      },
      {
        text: 'Groove doesn’t provide enough value or function',
        workflow: [
          {
            type: 'radio',
            question:
              'Which of the following best describes your reason for cancelling?',
            answers: [
              {
                text: 'Due to circumstances resulting from COVID-19',
                workflow: COVID19_CANCELLATION_WORKFLOW,
              },
              {
                text: 'I did not get sufficient value from Groove',
                workflow: STANDARD_CANCELLATION_WORKFLOW,
              },
              {
                text: 'Only wanted to see what Groove does',
                workflow: STANDARD_CANCELLATION_WORKFLOW,
              },
              {
                text: 'Groove lacks the features or functionality that I need ',
                workflow: STANDARD_CANCELLATION_WORKFLOW,
              },
              {
                text: 'The price is too expensive',
                workflow: STANDARD_CANCELLATION_WORKFLOW,
              },
              {
                text: 'Other',
                workflow: STANDARD_CANCELLATION_WORKFLOW,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    type: 'notice',
    question:
      'Your account has been cancelled.\nYou will be able to access your billing information within Groove for 3 months, afterwhich all information will be permanently deleted.',
  },
]

export default function withCancellationWorkflow(WrappedComponent) {
  return props => (
    <WrappedComponent workflow={CANCELLATION_WORKFLOW} {...props} />
  )
}
